// The bind-group numbers of the WebGPU backend.
//
// Both halves read this file: the WGSL headers are GENERATED from it, and
// the runtime builds its bind-group layouts from it. One file states the
// numbers, so a shader and the pipeline that feeds it cannot drift.
//
// Group 0 is what every pass shares: the uniform block at binding 0, with a
// DYNAMIC offset so one buffer holds one slice per draw, and the two
// samplers. Group 1 is the textures, and a texture's binding IS its unit
// from `gfx/worldquad.ts` `SAMPLER_UNITS`, so a pass that reads the owner
// plane reads it at binding 0 whichever pass it is.

/** Group 0: the uniform block and the samplers every pass shares. */
export const GROUP_SHARED = 0;

/** Group 1: the textures, bound at their unit. */
export const GROUP_TEXTURES = 1;

/** The uniform block. It carries a dynamic offset, one slice per draw. */
export const BINDING_UNIFORMS = 0;

/** The plane sampler: clamp, linear, no mip. */
export const BINDING_SAMPLER_LINEAR = 1;

/** The atlas sampler: clamp, trilinear. */
export const BINDING_SAMPLER_ATLAS = 2;

/** The name the WGSL gives the uniform block's struct. */
export const UNIFORM_STRUCT = 'Uniforms';

/** The name the WGSL gives the uniform block. Every read is `U.uName`. */
export const UNIFORM_VAR = 'U';

/** The name the WGSL gives the plane sampler. */
export const SAMPLER_LINEAR = 'sLinear';

/** The name the WGSL gives the atlas sampler. */
export const SAMPLER_ATLAS = 'sAtlas';

/**
 * The three bind-group layouts of the backend.
 *
 * They are EXPLICIT and never `layout: 'auto'`, because a shader that reads
 * a subset of the planes would otherwise take the whole group with it and no
 * two passes could share a bind group. `world` carries every plane, `sprite`
 * the atlas alone, and `none` no texture at all.
 */
export type BindGroupKind = 'world' | 'sprite' | 'none';

/** How many texture units the world group carries (`SAMPLER_UNITS` plus the
 *  four free units 5 to 8). A unit with nothing bound gets a placeholder. */
export const TEXTURE_UNITS = 12;
